import thirdPartyAuth from 'bundles/third-party-auth/lib';

export const getLinkedAccounts = function (actionContext: $TSFixMe) {
  actionContext.dispatch('LOADING', { action: 'getLinkedAccounts' });
  return thirdPartyAuth
    .getLinkedAccounts()
    .then((linkedAccounts) => {
      actionContext.dispatch('ACCOUNT_LINK_GET_ACCOUNT_SUCCESS', {
        linkedAccounts,
      });
    })
    .catch((error) => {
      actionContext.dispatch('ERROR', error);
    });
};

export const link = function (actionContext: $TSFixMe, payload: $TSFixMe) {
  const { accountType, ...data } = payload;
  actionContext.dispatch('CURRENT_ACCOUNT_SET', { currentAccount: accountType });
  actionContext.dispatch('LOADING', Object.assign({ action: 'link' }, payload));
  return thirdPartyAuth
    .link(accountType, data)
    .then((result) => {
      actionContext.dispatch('ACCOUNT_LINK_SUCCESS', { accountType, result });
    })
    .catch((error) => {
      actionContext.dispatch('ERROR', error);
    });
};

export const delink = function (actionContext: $TSFixMe, payload: $TSFixMe) {
  const { accountType, ...data } = payload;
  actionContext.dispatch('CURRENT_ACCOUNT_SET', { currentAccount: accountType });
  actionContext.dispatch('LOADING', Object.assign({ action: 'delink' }, payload));
  return thirdPartyAuth
    .delink(accountType, data)
    .then((result) => {
      actionContext.dispatch('ACCOUNT_DELINK_SUCCESS', { accountType, result });
    })
    .catch((error) => {
      actionContext.dispatch('ERROR', error);
    });
};
